import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byTrack: {},
    currentUserLearningAsset: {}
});

const getByTrackId = (state, sectionData) => {
    const { id, sectionId, data, isCompleted, completedDateTime, isAnswered, answeredDateTime } = sectionData;

    if (state.byTrack[sectionData.trackId]) {
        state.byTrack[sectionData.trackId][sectionData.id] = {
            id,
            sectionId,
            data,
            isCompleted,
            completedDateTime,
            isAnswered,
            answeredDateTime
        };
    } else {
        state.byTrack[sectionData.trackId] = {
            [sectionData.id]: { id, sectionId, data, isCompleted, completedDateTime, isAnswered, answeredDateTime }
        };
    }
};

export default (state = getInitialState(), action) => {
    let sectionData;
    switch (action.type) {
        case ACTIONS.UPDATE_SECTION: {
            sectionData = action.payload;
            const newState = { ...state };
            getByTrackId(newState, sectionData);
            return {
                ...newState
            };
        }
        case ACTIONS.GET_SECTIONS: {
            sectionData = action.payload.completedSectionItems;
            const trackId = action.payload._id;
            const newState = { ...state };
            if (sectionData) {
                Object.keys(sectionData).forEach((key) => {
                    const completedData = { ...sectionData[key], trackId };
                    getByTrackId(newState, completedData);
                });
            }
            return {
                ...newState
            };
        }
        case ACTIONS.RESET_USERLEARNINGASSET_SUCCESS: {
            const { userLearningAsset } = action.payload;
            const newState = { ...state };

            newState.byTrack[userLearningAsset._id] = {};

            return {
                ...newState
            };
        }

        case ACTIONS.UPDATE_WORKSPACE_ASSET: {
            const { userLearningAsset } = action.payload;
            const newState = { ...state };
            const newCurrentUserLearningAsset = { ...state.currentUserLearningAsset, ...userLearningAsset };
            newState.currentUserLearningAsset = { ...newCurrentUserLearningAsset };

            return {
                ...newState
            };
        }

        case ACTIONS.UPDATE_WORKSPACE_ASSET_METADATA: {
            const { status, updatedOn } = action.payload;
            const newState = { ...state };
            const newCurrentUserLearningAsset = {
                ...state.currentUserLearningAsset,
                status,
                updatedOn
            };
            newState.currentUserLearningAsset = { ...newCurrentUserLearningAsset };

            return {
                ...newState
            };
        }

        case ACTIONS.UPDATE_WORKSPACE_ASSET_COMPLETED_SECTIONITEMS: {
            const { completedSectionItem } = action.payload;
            const newCompleteSectionItems = {
                ...state.currentUserLearningAsset.completedSectionItems,
                ...completedSectionItem
            };
            return {
                ...state,
                currentUserLearningAsset: {
                    ...state.currentUserLearningAsset,
                    completedSectionItems: {
                        ...newCompleteSectionItems
                    }
                }
            };
        }

        case ACTIONS.SET_WORKSPACE_ACTIVE_SLIDE_NUMBER: {
            const activeSlideNumber = action.payload;
            return {
                ...state,
                activeSlideNumber
            };
        }

        case ACTIONS.CLEAR_WORKSPACE_ASSET: {
            return {
                ...state,
                currentUserLearningAsset: {}
            };
        }

        default:
            return state;
    }
};
